import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const axiosInstance = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
});

// Add token to requests
axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export const getChatUsers = async () => {
        const response = await axiosInstance.get('/admin/chat-get-user');
        return response.data;
};
export const getChatMessages = async (userId) => {
        const response = await axiosInstance.post('/admin/chat-get-messages', {
            user_id: userId 
        });     
};

export const sendChatMessage = async (receiverId, message) => {

        const response = await axiosInstance.post('/admin/chat-send-message', {
            receiver_id: receiverId,
            message: message
        });
        return response.data;
   
};